import { createTheme } from '@mui/material/styles';
import { colorsToken } from './colors-token';
import { typographyToken } from './typography-token';
import { grey } from '@mui/material/colors';

export const DARK_PRIMARY_COLOR = colorsToken.colors.primary['500'];
export const DARK_SECONDARY_COLOR = grey[400];

const darkTheme = createTheme({
	palette: {
		mode: 'dark',
		primary: {
			main: DARK_PRIMARY_COLOR,
			light: colorsToken.colors.primary['200'],
			dark: colorsToken.colors.primary['600'],
		},
		secondary: { main: DARK_SECONDARY_COLOR },

		background: {
			default: '#1c1c1c',
			paper: '#121212',
		},
		text: {
			primary: colorsToken.colors.white,
			secondary: colorsToken.colors.neutral['400'],
		},
		success: { main: colorsToken.colors.success['500'] },
		warning: { main: colorsToken.colors.info['600'] },
		error: { main: colorsToken.colors.error['500'] },
		info: { main: colorsToken.colors.info['500'] },
	},

	// SAME POSITION, SAME STRUCTURE
	typography: {
		fontFamily: [
			'Brown',
			'-apple-system',
			'BlinkMacSystemFont',
			'"Segoe UI"',
			'Roboto',
			'"Helvetica Neue"',
			'Arial',
			'sans-serif',
			'"Apple Color Emoji"',
			'"Segoe UI Emoji"',
			'"Segoe UI Symbol"',
		].join(','),
		fontWeightLight: Number(typographyToken.fontWeight.light),
		fontWeightRegular: Number(typographyToken.fontWeight.regular),
		fontWeightBold: Number(typographyToken.fontWeight.bold),

		h3: {
			fontSize: typographyToken.fontSize['2x-large'][0],
			lineHeight: typographyToken.fontSize['2x-large'][1],
			fontWeight: 'bold',
		},
		h5: {
			fontSize: typographyToken.fontSize.large[0],
			lineHeight: typographyToken.fontSize.large[1],
			fontWeight: 'bold',
		},
		h6: {
			fontSize: typographyToken.fontSize.medium[0],
			lineHeight: typographyToken.fontSize.medium[1],
			fontWeight: 500,
		},
		body2: {
			fontSize: typographyToken.fontSize.small[0],
			lineHeight: typographyToken.fontSize.small[1],
			fontWeight: 500,
		},
	},

	// SAME COMPONENT BLOCK, JUST COLORS ADAPTED FOR DARK
	components: {
		MuiTypography: {
			styleOverrides: {
				h3: { color: DARK_PRIMARY_COLOR }, // same pattern
				h5: { color: DARK_PRIMARY_COLOR },
				h6: { color: DARK_PRIMARY_COLOR },
				body2: { color: DARK_SECONDARY_COLOR },
			},
			variants: [
				{
					props: { variant: 'h3' },
					style: ({ theme }) => ({
						color: theme.palette.primary.main,
					}),
				},
				{
					props: { variant: 'h5' },
					style: ({ theme }) => ({
						color: theme.palette.primary.main,
					}),
				},
				{
					props: { variant: 'h6' },
					style: ({ theme }) => ({
						color: theme.palette.primary.main,
					}),
				},
				{
					props: { variant: 'body2' },
					style: ({ theme }) => ({
						color: theme.palette.text.secondary,
					}),
				},
			],
		},

		MuiCard: {
			styleOverrides: {
				root: {
					borderRadius: 10,
					backgroundColor: '#242424',
					color: colorsToken.colors.white,
				},
			},
		},
		MuiButton: {
			styleOverrides: {
				root: {
					textTransform: 'unset',
					color: colorsToken.colors.white,
				},
			},
		},
		MuiInputBase: {
			styleOverrides: {
				root: {
					backgroundColor: '#333',
					color: colorsToken.colors.white,
				},
			},
		},
		MuiAlert: { styleOverrides: { root: { borderRadius: 10 } } },
	},
});

export default darkTheme;
